import { useCallback, useEffect, useState } from "react";
import { SortableItem } from "ui/components/SortableItem";

import ModalQuestao from "./ModalQuestao";
import colors from "core/resources/theme/colors";
import SortableList from "ui/components/SortableList";
import { showConfirm } from "infra/helpers/alerta";
import {
  VotacaoForm,
  VotacaoPerguntaForm,
} from "core/features/assembleia/typings";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import SelectTipoVotacao from "components/Input/SelectTipoVotacao";
import SelectAmbienteVotacao from "components/Input/SelectAmbienteVotacao";
import Button from "ui/components/Button";
import { useForm } from "react-hook-form";
import { FaEdit, FaTrash } from "react-icons/fa";
import Field from "ui/components/Input/Field";
import { Box, Divider, Flex, Text } from "@chakra-ui/layout";
import { Col, Empty, Row } from "antd";
import { Switch } from "@chakra-ui/switch";
import {
  TipoVotacaoEnum,
  AmbienteVotacaoEnum,
} from "core/features/assembleia/enums";
import { CloseModalButton } from "components/Button/CloseModalButton";
import history from "infra/helpers/history";
import moment from "moment";

function FormQuestoes({
  value,
  onSubmit,
  isLoading,
}: {
  value?: VotacaoForm;
  isLoading: boolean;
  onSubmit: (v: any) => void;
}) {
  const { handleSubmit, reset, watch, setValue, control } =
    useForm<VotacaoForm>({
      defaultValues: {
        perguntas: [],
        horaCheckin: null,
      },
    });

  const [indexQuestao, setIndexQuestao] = useState<number | null>(null);
  const [openModalQuestao, handleOpenModalQuestao] = useState<boolean>(false);

  useEffect(() => {
    const mappedPerguntas =
      value?.perguntas.map((pergunta) => ({
        ...pergunta,
        dataEncerramento: pergunta.dataEncerramento
          ? moment(pergunta.dataEncerramento).format("YYYY-MM-DDTHH:mm")
          : null,
      })) || [];

    reset({ ...value, perguntas: mappedPerguntas });
  }, [value, reset]);

  const _onSubmit = useCallback(
    (values) => {
      values.perguntas = values.perguntas ?? [];

      onSubmit(values);
    },
    [onSubmit]
  );

  const form = watch();

  const perguntas = form.perguntas ?? [];

  return (
    <>
      {openModalQuestao ? (
        <ModalQuestao
          open={openModalQuestao}
          value={perguntas[indexQuestao as number] ?? {}}
          onClose={() => {
            handleOpenModalQuestao(false);
            setIndexQuestao(null);
          }}
          onChange={(questao: VotacaoPerguntaForm) => {
            questao.ativo = true;

            if (indexQuestao !== null) {
              perguntas[indexQuestao] = questao;
            } else {
              perguntas.push(questao);
            }

            setValue("perguntas", perguntas);

            handleOpenModalQuestao(false);
            setIndexQuestao(null);
          }}
        />
      ) : null}

      <form
        id="cadastrar-area-comum"
        onSubmit={(e) => handleSubmit(_onSubmit)(e)}
      >
        <div style={{ marginTop: 0 }}>
          <Box mb="16px">
            <Row gutter={16}>
              <Col sm={24}>
                <Field
                  label="Nome"
                  name="nome"
                  rules={{ required: true }}
                  control={control}
                />
              </Col>
            </Row>
          </Box>

          <Box mb="16px">
            <Row gutter={16}>
              <Col sm={6}>
                <Field
                  label="Data Inicio"
                  name="dataInicio"
                  inputProps={{ type: "date" }}
                  control={control}
                  rules={{
                    required: "Informe a data de inicio da votação",
                  }}
                />
              </Col>

              <Col sm={6}>
                <Field
                  label="Horário de Inicio da votação"
                  name="horaInicio"
                  inputProps={{ type: "time" }}
                  control={control}
                  rules={{
                    required: "Informe a hora de inicio da votação",
                  }}
                />
              </Col>

              <Col sm={6}>
                <Field
                  label="Data de Fim"
                  name="dataFim"
                  inputProps={{ type: "date" }}
                  control={control}
                />
              </Col>

              <Col sm={6}>
                <Field
                  label="Horário de fim"
                  name="horaFim"
                  inputProps={{ type: "time" }}
                  control={control}
                />
              </Col>
            </Row>
          </Box>

          <Box mb="16px">
            <Row gutter={16}>
              <Col sm={6}>
                <Field
                  label="Tipo de Votação"
                  name="tipoVotacaoId"
                  control={control}
                  rules={{
                    required: true,
                  }}
                  render={({ field, isInvalid }) => (
                    <SelectTipoVotacao
                      {...field}
                      onChange={(v) => {
                        field.onChange(v);

                        setValue("ambienteVotacaoId", null);
                        setValue("horaCheckin", null);
                      }}
                      isInvalid={isInvalid}
                    />
                  )}
                />
              </Col>
              {TipoVotacaoEnum.Assembleia === form.tipoVotacaoId ? (
                <Col sm={6}>
                  <Field
                    label="Ambiente da Votação"
                    name="ambienteVotacaoId"
                    control={control}
                    rules={{
                      required: true,
                    }}
                    render={({ field, isInvalid }) => (
                      <SelectAmbienteVotacao
                        {...field}
                        onChange={(v) => {
                          field.onChange(v);

                          if (
                            !form.ambienteVotacaoId ||
                            AmbienteVotacaoEnum.Presencial ===
                              form.ambienteVotacaoId
                          ) {
                            setValue("horaCheckin", null);
                          }
                        }}
                        isInvalid={isInvalid}
                      />
                    )}
                  />
                </Col>
              ) : null}

              {AmbienteVotacaoEnum.Presencial !== form.ambienteVotacaoId &&
              form.ambienteVotacaoId ? (
                <Col sm={12}>
                  <Field
                    label="Hora de inicio de check-in dos participantes"
                    name="horaCheckin"
                    inputProps={{ type: "time" }}
                    rules={{
                      required: "Informe a hora do check-in da votação",
                    }}
                    control={control}
                  />
                </Col>
              ) : null}
            </Row>
          </Box>

          {AmbienteVotacaoEnum.Presencial !== form.ambienteVotacaoId &&
          form.ambienteVotacaoId ? (
            <Box mb="16px">
              <Row gutter={16}>
                <Col sm={12}>
                  <Field
                    label="Link videoconferência"
                    name="webinarJoinUrl"
                    control={control}
                  />
                </Col>
              </Row>
            </Box>
          ) : null}

          <Box pt="24px">
            <Field
              name="ativo"
              control={control}
              render={({ field }) => (
                <Switch
                  onChange={() => {
                    field.onChange(!field.value);
                  }}
                  isChecked={!!field.value}
                >
                  Ativo
                </Switch>
              )}
            />
          </Box>

          <Divider my={"16px"} />

          <div style={{ textAlign: "right", marginBottom: 16 }}>
            <Button onClick={() => handleOpenModalQuestao(true)}>
              ADICIONAR QUESTÃO
            </Button>
          </div>

          <div>
            <SortableList
              value={perguntas}
              onChange={(v: any) => {
                setValue("perguntas", v);
              }}
              renderItem={(item: any, index: number) => (
                <SortableItem
                  key={index}
                  subtitle={`${index + 1}º - ${item.titulo}`}
                  right={
                    <Flex gridGap="16px" alignItems="center">
                      <Box>
                        <Text>Ativo</Text>
                        <Switch
                          onChange={() => {
                            perguntas[index].ativo = !item.ativo;
                            setValue("perguntas", perguntas);
                          }}
                          isChecked={!!item.ativo}
                        />
                      </Box>
                      <Box>
                        <Text>Data de encerramento</Text>
                        <Field
                          inputProps={{ type: "datetime-local" }}
                          name={`perguntas.${index}.dataEncerramento`}
                          control={control}
                        />
                      </Box>
                      <Button
                        mt="auto"
                        onClick={() => {
                          setIndexQuestao(index);
                          handleOpenModalQuestao(true);
                        }}
                      >
                        <FaEdit color={colors.primary} />
                      </Button>

                      <Button
                        mt="auto"
                        onClick={() => {
                          showConfirm("Deseja realmente excluir ?").then(
                            (result: any) => {
                              if (result.isConfirmed) {
                                setValue(
                                  "perguntas",
                                  perguntas.filter((el: any) => el !== item)
                                );
                              }
                            }
                          );
                        }}
                      >
                        <FaTrash color={colors.red500} />
                      </Button>
                    </Flex>
                  }
                />
              )}
            />

            {perguntas.length === 0 ? (
              <Empty description="Nenhuma questão adicionada" />
            ) : null}
          </div>
        </div>

        <Flex mt="32px" gridGap="16px" justifyContent="flex-end">
          <CloseModalButton
            closeModalLabel="Cancelar"
            close={() => history.push("/administracao/assembleias")}
          />
          <PrimaryButton
            isDisabled={isLoading}
            isLoading={isLoading}
            type="submit"
          >
            SALVAR
          </PrimaryButton>
        </Flex>
      </form>
    </>
  );
}

export default FormQuestoes;
